<template>
    <form @submit.prevent="debouncedGetEventos">
        <div class="input-group w-100 bg-white border search-container">
            <input type="search" class="form-control border-0 search-input" v-model="search" :placeholder="placeholder" @input="debouncedGetEventos"/>
            <button type="submit" class="button">{{ $t("partido.buscar") }}</button>
        </div>
    </form>
</template>

<script>
    export default {
        props: ["placeholder", "teatro"],
        data() {
            return {
                search: null
            }
        },
        created() {
            this.debouncedGetEventos = _.debounce(this.getEventos, 500)
        },
        methods: {
            getEventos() {
                this.$emit('search-events', this.search);
            }
        },
    }
</script>

<style scoped>
    .search-container {
        background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDIwIDIwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMjAgMTguNjNsLTQuNTItNC41MmE4LjY1NiA4LjY1NiAwIDAwMS45MS01LjQyYzAtNC43OS0zLjktOC42OS04LjctOC42OVMwIDMuOSAwIDguNjlzMy45IDguNjkgOC42OSA4LjY5YzIuMDUgMCAzLjkzLS43MiA1LjQyLTEuOTFMMTguNjMgMjAgMjAgMTguNjN6TTEuOTMgOC42OWMwLTMuNzMgMy4wMy02Ljc2IDYuNzYtNi43NnM2Ljc2IDMuMDMgNi43NiA2Ljc2LTMuMDMgNi43Ni02Ljc2IDYuNzYtNi43Ni0zLjAzLTYuNzYtNi43NnoiIGZpbGw9IiM2MjY3NmUiLz48L3N2Zz4=);
        background-repeat: no-repeat;
        background-position: 42px;
        background-size: 20px 20px;
        height: 72px;
    }

    .search-input {
        margin-left:80px;
    }

    button {
        padding-right: 3rem;
        padding-left: 3rem;
    }

    @media (max-width: 700px) {
        .search-container {
            background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMCIgeT0iMCIgdmlld0JveD0iMCAwIDIwIDIwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNMjAgMTguNjNsLTQuNTItNC41MmE4LjY1NiA4LjY1NiAwIDAwMS45MS01LjQyYzAtNC43OS0zLjktOC42OS04LjctOC42OVMwIDMuOSAwIDguNjlzMy45IDguNjkgOC42OSA4LjY5YzIuMDUgMCAzLjkzLS43MiA1LjQyLTEuOTFMMTguNjMgMjAgMjAgMTguNjN6TTEuOTMgOC42OWMwLTMuNzMgMy4wMy02Ljc2IDYuNzYtNi43NnM2Ljc2IDMuMDMgNi43NiA2Ljc2LTMuMDMgNi43Ni02Ljc2IDYuNzYtNi43Ni0zLjAzLTYuNzYtNi43NnoiIGZpbGw9IiM2MjY3NmUiLz48L3N2Zz4=);
            background-repeat: no-repeat;
            background-position: 10px;
            background-size: 15px 15px;
            height: 60px;
        }

        .search-input {
            margin-left: 25px;
            margin-right: 0;
            padding-right: 0;
        }

        button {
            padding-right: 1.4rem;
            padding-left: 1.4rem;
        }
    }    
</style>
